import { createTheme } from '@mui/material/styles';

export const inplayTheme = createTheme({
  palette: {
    primary: {
      // Usa suas variáveis do :root/.color-theme-inplay
      main: '#DF3164',
      // Seu shade é mais claro (#ff719c) → vai em "light"
      light: '#ff719c',
      // Seu tint é mais escuro (#bd1246) → vai em "dark"
      dark: '#bd1246',
      contrastText: '#fff',
    },
  },
  components: {
    MuiTabs: {
      defaultProps: {
        textColor: 'primary',
        indicatorColor: 'primary',
      },
    },
  },
});
